import { render, staticRenderFns } from "./GameCategoryLobby.vue?vue&type=template&id=4cd807a6&scoped=true"
import script from "./GameCategoryLobby.vue?vue&type=script&lang=js"
export * from "./GameCategoryLobby.vue?vue&type=script&lang=js"
import style0 from "./GameCategoryLobby.vue?vue&type=style&index=0&id=4cd807a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd807a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd807a6')) {
      api.createRecord('4cd807a6', component.options)
    } else {
      api.reload('4cd807a6', component.options)
    }
    module.hot.accept("./GameCategoryLobby.vue?vue&type=template&id=4cd807a6&scoped=true", function () {
      api.rerender('4cd807a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lobby/GameCategoryLobby.vue"
export default component.exports